import { useCanEditFabric } from '@common/Fabric/useCanEditFabric';
import { Private_Routes } from '@common/url';
import { Navigate } from 'react-router-dom';

import { useEnvConfig } from '../../context/envConfig';

export const withFabricCreationValidation = <T extends {}>(WrappedComponent: React.FC<T>) => {
  return (props: T) => {
    const {
      actions: { hasFabricCrudOperationAccess }
    } = useCanEditFabric();

    const {
      fabrics: {
        crud: { creationVisible }
      }
    } = useEnvConfig();

    if (!hasFabricCrudOperationAccess('', false).allowed || !creationVisible) {
      return <Navigate to={Private_Routes.Home.url} replace />;
    }

    return <WrappedComponent {...props} />;
  };
};
